var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:bank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.9965 5.83341H10.004M3.33317 8.33342V15.4167M6.6665 8.33342V15.4167M13.3332 8.33342V15.4167M16.6665 8.33342V15.4167M1.6665 7.14175C1.6665 6.14425 2.06817 5.53341 2.89984 5.07008L6.32484 3.16425C8.119 2.16675 9.0165 1.66675 9.99984 1.66675C10.9832 1.66675 11.8807 2.16675 13.6748 3.16425L17.0998 5.07008C17.9307 5.53341 18.3332 6.14425 18.3332 7.14175C18.3332 7.41175 18.3332 7.54758 18.304 7.65841C18.149 8.24175 17.6198 8.33425 17.109 8.33425H2.89067C2.37984 8.33425 1.8515 8.24258 1.69567 7.65841C1.6665 7.54675 1.6665 7.41175 1.6665 7.14175ZM15.8332 15.4167H4.1665C3.50346 15.4167 2.86758 15.6801 2.39874 16.149C1.9299 16.6178 1.6665 17.2537 1.6665 17.9167C1.6665 18.0273 1.7104 18.1332 1.78854 18.2114C1.86668 18.2895 1.97266 18.3334 2.08317 18.3334H17.9165C18.027 18.3334 18.133 18.2895 18.2111 18.2114C18.2893 18.1332 18.3332 18.0273 18.3332 17.9167C18.3332 17.2537 18.0698 16.6178 17.6009 16.149C17.1321 15.6801 16.4962 15.4167 15.8332 15.4167Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.bbb49f871df9986fbae41f08ebf5b2f3.svg";
export { ForwardRef as ReactComponent };